interface Props {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  /** 한 번에 보여 줄 페이지 번호 개수 */
  window?: number;
}

/** 1부터 시작하는 페이지네이션. */
export default function Pagination({ page, totalPages, onChange, window = 5 }: Props) {
  if (totalPages <= 1) return null;

  const half = Math.floor(window / 2);
  let start = Math.max(1, page - half);
  const end = Math.min(totalPages, start + window - 1);
  start = Math.max(1, end - window + 1);

  const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  return (
    <nav className="pagination" aria-label="페이지 이동">
      <button type="button" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        ‹
      </button>
      {start > 1 && (
        <button type="button" onClick={() => onChange(1)}>
          1
        </button>
      )}
      {start > 2 && <span style={{ alignSelf: 'center' }}>…</span>}
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          className={p === page ? 'is-active' : undefined}
          onClick={() => onChange(p)}
          aria-current={p === page ? 'page' : undefined}
        >
          {p}
        </button>
      ))}
      {end < totalPages - 1 && <span style={{ alignSelf: 'center' }}>…</span>}
      {end < totalPages && (
        <button type="button" onClick={() => onChange(totalPages)}>
          {totalPages}
        </button>
      )}
      <button type="button" disabled={page >= totalPages} onClick={() => onChange(page + 1)}>
        ›
      </button>
    </nav>
  );
}
